import React from 'react';
import { useHistory } from 'react-router-dom';

import { useQuery, useMutation, useQueryClient } from '@sopranodesign/pulse-hooks';
import {
  PageWrapper,
  Placeholder,
  useNotification
} from '@sopranodesign/pulse-components';

import { McpSkillDetails } from '../Components/index';
import { updateSkill } from '../api/index';

const EditMcpSkill = ({ match }) => {
  const history = useHistory();
  const { showSuccess } = useNotification();
  const queryClient = useQueryClient();

  const id = match.params.id;

  const query = useQuery({ queryKey: [`mcp-skills/${id}`] });

  const mutation = useMutation({
    mutationFn: updateSkill,
    onSuccess: () => {
      showSuccess('Skill updated');
      queryClient.invalidateQueries(`mcp-skills/${id}`);
      queryClient.invalidateQueries('mcp-skills');
      history.goBack();
    }
  });

  return (
    <PageWrapper
      header="Edit MCP Skill"
      subheader="Update skill definition">
      {query.isLoading && <Placeholder />}
      {query.isSuccess && (
        <McpSkillDetails
          handleSubmit={form => mutation.mutate({ id, ...form })}
          loading={mutation.isPending}
          initialSkill={query.data.data}
        />
      )}
    </PageWrapper>
  );
};

export default EditMcpSkill;
